export function createQuantityOptions(args?: {
  max?: number; //
  step?: number;
  includeZero?: boolean;
  zeroLabel?: string;
  unitLabel?: (n: number) => string;
}): QuantityOption[] {
  const max = args?.max ?? 20;
  const step = args?.step ?? 1;
  const includeZero = args?.includeZero ?? true;

  const zeroLabel = args?.zeroLabel ?? "Selecione uma opção";
  const unitLabel = args?.unitLabel ?? ((n) => `${n}`);

  const opts: QuantityOption[] = [];

  if (includeZero) {
    opts.push({ value: 0, label: zeroLabel });
  }

  for (let n = step; n <= max; n += step) {
    opts.push({ value: n, label: unitLabel(n) });
  }

  return opts;
}

// normaliza o que vier da flag (string JSON, array, etc)
export type QuantityOption = { value: number; label: string };

const ZERO_OPTION: QuantityOption = {
  value: 0,
  label: "0",
};

export function normalizeQuantityOptions(
  raw: unknown,
  options?: {
    includeZero?: boolean;
    zeroLabel?: string;
  }
): QuantityOption[] | null {
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;

    if (!Array.isArray(parsed)) return null;

    let mapped: QuantityOption[] | null = null;

    // 🔹 Formato novo: { value: number; label: string }
    if (
      parsed.every(
        (x) => x && typeof x === "object" && "value" in x && "label" in x
      )
    ) {
      mapped = parsed.map((x: any) => ({
        value: Number(x.value),
        label: String(x.label),
      }));
    }

    // 🔹 Formato legado: { key: string; value: string }
    if (
      !mapped &&
      parsed.every(
        (x) => x && typeof x === "object" && "key" in x && "value" in x
      )
    ) {
      mapped = parsed.map((x: any) => ({
        value: Number(x.key),
        label: String(x.value),
      }));
    }

    if (!mapped) return null;

    // validação básica
    if (!mapped.every((o) => Number.isFinite(o.value) && o.label)) {
      return null;
    }

    // 🔹 inclusão explícita do ZERO
    const includeZero = options?.includeZero ?? true;
    if (includeZero && !mapped.some((o) => o.value === 0)) {
      mapped = [
        {
          value: 0,
          label: options?.zeroLabel ?? ZERO_OPTION.label,
        },
        ...mapped,
      ];
    }

    return mapped;
  } catch {
    return null;
  }
}
